import React from 'react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

const AuthInput = React.forwardRef((
  {
    label,
    name,
    type = "text",
    autoComplete,
    placeholder,
    value,
    onChange,
    error,
    isOptional = false,
    showPasswordToggle = false,
    onTogglePasswordVisibility,
    isPasswordVisible,
    inputClassName = '',
    labelClassName = '',
    wrapperClassName = 'mb-4 md:mb-6',
    children,
  },
  ref
) => {
  const hasError = !!error;

  return (
    <div className={wrapperClassName}>
      {label && (
        <label htmlFor={name} className={`block text-sm font-medium text-brand-text-dark mb-1.5 ${labelClassName}`}>
          {label} {!isOptional && <span className="text-red-500">*</span>}
        </label>
      )}
      <div
        className={`bg-white p-0 rounded-lg shadow-sm ring-1 ring-inset ${hasError ? 'ring-red-500' : 'ring-gray-300 focus-within:ring-2 focus-within:ring-brand-green-medium'} transition-all duration-150 ease-in-out flex items-center`}
      >
        <input
          ref={ref}
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          className={`w-full bg-transparent border-0 focus:outline-none focus:ring-0 text-brand-text-dark placeholder-gray-400 py-3 px-4 ${inputClassName}`}
          aria-invalid={hasError}
          aria-describedby={hasError ? `${name}-error` : undefined}
        />
        {showPasswordToggle && onTogglePasswordVisibility && (
          <button
            type="button"
            onClick={onTogglePasswordVisibility}
            className="p-2 text-gray-500 hover:text-brand-green-dark focus:outline-none mr-2"
            aria-label={isPasswordVisible ? "Hide password" : "Show password"}
          >
            {isPasswordVisible ? (
              <EyeSlashIcon className="h-5 w-5" />
            ) : (
              <EyeIcon className="h-5 w-5" />
            )}
          </button>
        )}
      </div>
      {children}
      {hasError && (
        <p id={`${name}-error`} className="mt-1.5 text-xs text-red-600">
          {error}
        </p>
      )}
    </div>
  );
});

AuthInput.displayName = 'AuthInput';

export default AuthInput;
